import MachineModal from "./MachineModal";

export default MachineModal;
